// extracted by mini-css-extract-plugin
export default {"quantity_container":"JF","hiddenflavorstring":"KF","loadingLine":"LF","productimgwrap":"MF","productimg":"NF","circlepic":"OF","productinfo":"PF","grey_x":"QF","cartrow":"RF","bold":"SF","title":"TF","blue":"UF","strike":"VF","flexgap":"WF","flavorstring":"XF","nodecorate":"YF","flavorstring_link":"ZF","rdstring":"aG","removeditemblock":"bG","removed_heading":"cG","removed_text":"eG","addback":"fG"};
    if(module.hot) {
      // 1713969933516
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  